import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { HTTPService } from "./../../../services/httpService";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';
import CalendarCard from './calendarCard';
import CalendarGrid from './CalendarGrid';
import { ViewJob } from '../requestimates/displayJob';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Select from './../../../components/common/select';
import LocationService, { US_HOLIDAYS, formatHolidayDate } from './../../../services/locationService';

const API = new HTTPService();

// Constants
const DESKTOP_BREAKPOINT = 1024;
const DEFAULT_CAPACITY = 8;
const DATE_FORMAT = "ddd Do MMM";

class Calendar extends Component {
    state = {
        installer: {},
        calendarDays: [],
        blockedDays: [],
        selectedDate: {},
        today: "",
        thisDay: "",
        thisWeek: "",
        thisMonth: "",
        selectedWeek: "",
        selectedMonth: "",
        startDate: "",
        duration: 0,
        range: "week", // Changed default to week for better desktop experience
        displayString: "",
        userType: this.props.userType,
        typeId: this.props.typeId,
        calendarDay: {
            calendarDate: "",
            countDraft: 0,
            countPending: 0,
            countBooked: 0
        },
        displayDays: [],
        loggedIn: false,
        // Job details popup
        showDetails: false,
        selectedRequestimate: {},
        services: {},
        notes: {},
        // Simplified sync state - only bulk
        isBulkSyncing: false,
        isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
        expandedCards: new Set(), // Track multiple expanded cards
        error: null,
        // Calendar connection state
        isCalendarConnected: false,
        calendarConnectionError: null,
        showCalendarSelection: false,
        availableCalendars: [],
        // Technician filter state (following newFinancials pattern)
        technicians: [],
        technicianOptions: ["All Technicians"],
        selectedTechnician: "All Technicians",
        hasTechnicians: false,
        // Holidays Modal state
        showHolidaysModal: false,
        holidayBlockedDates: [],
        holidaysLoading: false,
        // Custom Closures Modal state
        showCustomClosuresModal: false,
        customClosures: [],
        newClosureStart: '',
        newClosureEnd: '',
        newClosureReason: '',
        closuresLoading: false,
        // Grid view state — grid default on desktop, cards on mobile
        viewMode: window.innerWidth >= DESKTOP_BREAKPOINT ? 'grid' : 'cards',
        // Operating hours (for closed-day detection in grid view)
        operatingHours: [],
    };

    async componentDidMount() {
  console.log('📱 Calendar component mounting...');
  console.log('🆔 typeId:', this.state.typeId);
            this.handleOAuthRedirect();
            
        try {
            // Get all the calendar events for the installer
            let installerRequest = `/installerLocations/${this.state.typeId}`;
            const { data: installer } = await API.get(installerRequest);

            const firstOne = installer.shift();
            this.setState({ installer: firstOne });

            // Check calendar connection status
     //       await this.checkCalendarConnection();

            // Get calendar data - only booked jobs now
            const locationId = this.props.selectedLocationId;
            const locationParam = (locationId && locationId !== 'all') ? `?locationId=${locationId}` : '';

            let calendarRequest = `/dealerCalendars/${this.state.typeId}${locationParam}`;
            const { data: dealerCalendarDays } = await API.get(calendarRequest);

            calendarRequest = `/installerCalendars/${this.state.typeId}${locationParam}`;
            const { data: installerCalendarDays } = await API.get(calendarRequest);

            var calendarDays = dealerCalendarDays.concat(installerCalendarDays);

            // Only show confirmed/active/completed work — drafts/estimates don't have real scheduled dates
            calendarDays = calendarDays.filter(job => job.workStatus === "booked" || job.workStatus === "started" || job.workStatus === "finished" || job.workStatus === "completed");
            
            calendarDays = _.orderBy(calendarDays, ['workDate'], ['asc']);

            // Filter to only show future dates
            var today = moment.utc();
            var start = moment.utc().startOf('week'); // Start with beginning of week
            var end = moment.utc().endOf('week'); // End with end of week
            
            this.setState({ 
                today,
                thisDay: moment(today), // Clone the moment object
                thisWeek: today.week(),
                selectedWeek: moment().format("w"),
                thisMonth: today.month(),
                selectedMonth: moment().format("M"),
                displayString: this.getDisplayString(start, "week"),
                startDate: start, 
                endDate: end, 
                selectedDate: moment(start), // Clone
                calendarDays
            }, () => {
                // After calendar data is loaded, set default expanded cards
                this.setDefaultExpandedCardsIfNeeded();
            });

            // Set up blocked days
            calendarRequest = `/installerBlockedCalendars/${this.state.typeId}`;
            const { data: blockedDays } = await API.get(calendarRequest);
            this.setState({ blockedDays });

        } catch (error) {
            console.error('Error loading calendar data:', error);
            this.setState({ 
                error: 'Failed to load calendar data. Please refresh the page.' 
            });
        }
// Check calendar connection status
  await this.checkCalendarConnection();

  // Handle OAuth redirect if present
  this.handleOAuthRedirect();

  // Load technicians for filter (if shop has technicians)
  await this.loadTechnicians();

  // Load blocked dates for holidays/closures management
  await this.loadBlockedDates();

  // Load operating hours (for closed weekday detection)
  await this.loadOperatingHours();

        // Handle responsive design
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
        const updates = { isDesktop };
        // Fall back to cards when going mobile (grid is desktop-only)
        if (!isDesktop && this.state.viewMode === 'grid') {
            updates.viewMode = 'cards';
        }
        this.setState(updates);
    };

    // Fetch technicians for this installer company (following newFinancials pattern)
    loadTechnicians = async () => {
        try {
            // Get users for this installer company with role = technician
            const response = await API.get(`/users?company_id=${this.state.typeId}&user_type=installer`);

            if (response.data && Array.isArray(response.data)) {
                // Filter to only technicians
                const technicians = response.data.filter(user => user.role === 'technician');

                if (technicians.length > 0) {
                    // Build options array like newFinancials: ["All Technicians", "John Smith", "Jane Doe"]
                    const technicianNames = technicians.map(tech =>
                        tech.user_name || tech.Email
                    );
                    const technicianOptions = ["All Technicians", ...technicianNames];

                    this.setState({
                        technicians,
                        technicianOptions,
                        hasTechnicians: true
                    });
                }
            }
        } catch (error) {
            console.error('Error loading technicians:', error);
            // Silently fail - technician filter just won't be available
        }
    };

    // Handle technician filter change (following newFinancials handleTypeChange pattern)
    handleTechnicianChange = (event) => {
        const { value } = event.currentTarget;
        this.setState({ selectedTechnician: value });
    };

checkCalendarConnection = async () => {
  try {
    const response = await API.get(`/installerAuth/${this.state.typeId}`);
    
    if (response.data && response.data[0]) {
      const { authenticated } = response.data[0];
      this.setState({
        isCalendarConnected: authenticated,
        calendarConnectionError: null 
      });
    } else {
      this.setState({ 
        isCalendarConnected: false,
        calendarConnectionError: 'Unable to check calendar status'
      });
    }
  } catch (error) {
    console.error('Error checking calendar status:', error);
    this.setState({ 
      isCalendarConnected: false,
      calendarConnectionError: 'Unable to check calendar status'
    });
  }
};

// Start OAuth flow from calendar page
connectCalendar = async () => {
  try {
    const locationId = this.props.selectedLocationId;
    if (!locationId || locationId === 'all') {
      alert('Please select a specific location before connecting a calendar.');
      return;
    }
    sessionStorage.setItem('calendar_page_locationId', String(locationId));
    const { data: authUrl } = await API.get(`/googlecal/auth/${this.state.typeId}?locationId=${locationId}`);
    window.location.href = authUrl;
  } catch (error) {
    console.error('Calendar connection error:', error);
    alert('Failed to connect calendar. Please try again.');
  }
};

handleOAuthRedirect = () => {
  console.log('🔍 handleOAuthRedirect called');
  console.log('🔍 Current URL:', window.location.href);
  console.log('🔍 Search params:', window.location.search);
  
  const urlParams = new URLSearchParams(window.location.search);
  
  // Log all URL parameters
  for (let [key, value] of urlParams.entries()) {
    console.log(`🔗 URL param: ${key} = ${value}`);
  }
  
  if (urlParams.get('calendar_selection')) {
    console.log('✅ Calendar selection parameter found');
    try {
      const calendarsParam = urlParams.get('calendars');
      const installerId = urlParams.get('installer_id');
      
      console.log('📄 Raw calendars param:', calendarsParam);
      console.log('🆔 Installer ID from URL:', installerId);
      console.log('🆔 Current typeId:', this.state.typeId);
      
      const calendars = JSON.parse(calendarsParam);
      console.log('📅 Parsed calendars:', calendars);
      console.log('📊 Number of calendars:', calendars.length);
      
      if (installerId === this.state.typeId.toString()) {
        // Read location_id from redirect URL, fallback to sessionStorage
        const locationId = urlParams.get('location_id') || sessionStorage.getItem('calendar_page_locationId');
        sessionStorage.removeItem('calendar_page_locationId');

        this.setState({
          showCalendarSelection: true,
          availableCalendars: calendars,
          calendarSelectionLocationId: locationId ? Number(locationId) || locationId : null
        });
      }
      
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (e) {
      console.error('❌ Error parsing calendar list:', e);
      alert('Error loading calendar options. Please try again.');
    }
  } else {
    console.log('ℹ️ No calendar_selection parameter found');
  }
};


handleCalendarSelection = async (selectedCalendar) => {
  try {
    await API.post('/googlecal/select', {
      installerId: this.state.typeId,
      calendarId: selectedCalendar.id,
      locationId: this.state.calendarSelectionLocationId
    });
    
    this.setState({ 
      showCalendarSelection: false,
      availableCalendars: [],
      isCalendarConnected: true
    });
    
    // Refresh navbar status
    window.dispatchEvent(new CustomEvent('calendarStatusChanged', { detail: { connected: true } }));
    
    alert(`Calendar "${selectedCalendar.name}" connected successfully!`);
  } catch (error) {
    console.error('Error saving calendar selection:', error);
    alert('Failed to save calendar selection. Please try again.');
  }
};

    getDisplayString = (date, range, serviceCount = 0) => {
        let dateString = "";
        if (range === "day") {
            dateString = date.format("ddd, MMM Do YYYY");
        } else if (range === "week") {
            const startOfWeek = moment(date).startOf("week");
            const endOfWeek = moment(date).endOf("week");
            dateString = startOfWeek.format("MMM Do") + " - " + endOfWeek.format("MMM Do, YYYY");
        } else if (range === "month") {
            const startOfMonth = moment(date).startOf("month");
            const endOfMonth = moment(date).endOf("month");
            dateString = startOfMonth.format("MMM Do") + " - " + endOfMonth.format("MMM Do, YYYY");
        } else {
            dateString = date.format("ddd, MMM Do YYYY");
        }
        
        if (serviceCount > 0) {
            return `${dateString} (${serviceCount} service${serviceCount !== 1 ? 's' : ''})`;
        }
        return dateString;
    };

    getPeriodRevenueLabel = () => {
        switch(this.state.range) {
            case 'day': return 'Day Revenue';
            case 'week': return 'Week Revenue'; 
            case 'month': return 'Month Revenue';
            default: return 'Period Revenue';
        }
    };

    handleClick = (event) => {
        const { value } = event.currentTarget;
        this.setState({ selectedDate: value });
    };

    navigate = async (url) => {
        window.location.href = url;
    }

    // Display job details when card is clicked
    displayDetails = async (requestId) => {
        try {
            let dispRequest = `/requestimates/fullrequest/?Id=${requestId}`;
            const { data: selectedRequests } = await API.get(dispRequest);

            let servicesRequest = `/requestservice/${requestId}`;
            const { data: services } = await API.get(servicesRequest);

            let notesRequest = `/requestnotes/${requestId}`;
            const { data: notes } = await API.get(notesRequest);

            this.setState({
                selectedRequestimate: selectedRequests[0],
                services,
                notes,
                showDetails: true
            });
        } catch (error) {
            console.error('Error loading job details:', error);
            alert('Error loading job details. Please try again.');
        }
    }

    addCustomClose = () => {
        this.setState({ showDetails: false });
    };

    // SIMPLIFIED: Only bulk sync now
    handleBulkSync = async () => {
        const unsyncedJobs = this.getUnsyncedJobs();
        
        if (unsyncedJobs.length === 0) {
            alert('All services are already synced to calendar.');
            return;
        }

        const message = `Add ${unsyncedJobs.length} unsynced services to Google Calendar?\n\nThis will create calendar events for all jobs from today forward that aren't already synced.`;
        
        if (!window.confirm(message)) {
            return;
        }

        this.setState({ isBulkSyncing: true });

        let successCount = 0;
        let errorCount = 0;
        let authError = false;
        
        // Process jobs in batches to avoid overwhelming the API
        const batchSize = 5;
        for (let i = 0; i < unsyncedJobs.length; i += batchSize) {
            const batch = unsyncedJobs.slice(i, i + batchSize);
            
            // eslint-disable-next-line no-loop-func
            const batchPromises = batch.map(async (job) => {
                try {
                    const appointmentData = {
                        request: job.requestId,
                        summary: job.workString,
                        description: "",
                        colorId: "6",
                        installerId: this.state.typeId
                    };
                    
                    const response = await API.put('/addAppt/', appointmentData);
                    
                    if (response.data && response.data.success) {
                        successCount++;
                    } else {
                        throw new Error(response.data?.error || 'Unknown error');
                    }
                    
                    // Small delay between requests in batch
                    await new Promise(resolve => setTimeout(resolve, 200));
                    
                } catch (error) {
                    console.error(`Failed to sync job ${job.requestId}:`, error);
                    
                    // Check for auth errors
                    if (error.response?.status === 401 || 
                        error.message?.includes('expired') || 
                        error.message?.includes('invalid_grant')) {
                        authError = true;
                    }
                    
                    errorCount++;
                }
            });
            
            await Promise.allSettled(batchPromises);
            
            // If we hit auth errors, stop processing
            if (authError) {
                break;
            }
            
            // Delay between batches
            if (i + batchSize < unsyncedJobs.length) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        this.setState({ isBulkSyncing: false });
        
        // Handle auth errors
        if (authError) {
            this.setState({ 
                isCalendarConnected: false,
                calendarConnectionError: 'Calendar connection expired'
            });
            
            alert('Your Google Calendar connection has expired. Please reconnect your calendar and try again.');
            return;
        }
        
        // Show results
        let resultMessage = `Bulk sync completed!\n\n`;
        resultMessage += `✅ Successfully synced: ${successCount} services\n`;
        
        if (errorCount > 0) {
            resultMessage += `❌ Failed to sync: ${errorCount} services\n\n`;
            resultMessage += `They can be synced individually by trying the bulk sync again.`;
        }
        
        alert(resultMessage);
        
        // Refresh calendar data to show updated sync status
        await this.refreshCalendarData();
    };

    getUnsyncedJobs = () => {
        // Get jobs from today forward that don't have calendar events
        const today = moment().startOf('day');
        
        return this.state.calendarDays
            .filter(job => {
                const jobDate = moment(job.workDate);
                return jobDate.isSameOrAfter(today) && !job.eventId;
            })
            .map(job => ({
                requestId: job.requestId,
                serviceId: job.serviceId,
                workString: job.category + " - " + job.description + " on " +
                           job.year + " " + job.make + " " + job.model + " " +
                           job.trim + " for " + job.dealerName
            }));
    };

    refreshCalendarData = async () => {
        try {
            // Re-fetch calendar data to get updated sync status
            const locationId = this.props.selectedLocationId;
            const locationParam = (locationId && locationId !== 'all') ? `?locationId=${locationId}` : '';

            let calendarRequest = `/dealerCalendars/${this.state.typeId}${locationParam}`;
            const { data: dealerCalendarDays } = await API.get(calendarRequest);

            calendarRequest = `/installerCalendars/${this.state.typeId}${locationParam}`;
            const { data: installerCalendarDays } = await API.get(calendarRequest);

            var calendarDays = dealerCalendarDays.concat(installerCalendarDays);
            calendarDays = calendarDays.filter(job => job.workStatus === "booked" || job.workStatus === "started" || job.workStatus === "finished" || job.workStatus === "completed");
            calendarDays = _.orderBy(calendarDays, ['workDate'], ['asc']);

            this.setState({ calendarDays });
        } catch (error) {
            console.error('Error refreshing calendar data:', error);
        }
    };


disconnectCalendar = async () => {
  if (!window.confirm('Are you sure you want to disconnect your Google Calendar? This will stop syncing jobs to your calendar.')) {
    return;
  }

  try {
    const locationId = this.props.selectedLocationId;
    if (!locationId || locationId === 'all') {
      alert('Please select a specific location before disconnecting a calendar.');
      return;
    }
    await API.delete(`/googlecal/disconnect/${this.state.typeId}?locationId=${locationId}`);
    
    this.setState({ 
      isCalendarConnected: false,
      calendarConnectionError: null 
    });
    
    // Refresh navbar status
    window.dispatchEvent(new CustomEvent('calendarStatusChanged', { detail: { connected: false } }));
    
    alert('Calendar disconnected successfully. You can reconnect anytime.');
  } catch (error) {
    console.error('Calendar disconnection error:', error);
    alert('Failed to disconnect calendar. Please try again.');
  }
};


// FIXED: Moment.js mutability issues
    handleDisplayRange = (event) => {
        const { value } = event.currentTarget;
        var newDay = moment(this.state.selectedDate || this.state.today); // Already cloned
        var displayString = "";
        var endDate;

        if (this.state.range === "day") {
            if (value === "today") {
                newDay = moment(); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "day"); // Clone before mutating
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "day"); // Clone before mutating
            }
            endDate = moment(newDay); // Clone for endDate
        }

        if (this.state.range === "week") {
            if (value === "today") {
                newDay = moment().startOf("week"); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "week").startOf("week"); // Clone first
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "week").startOf("week"); // Clone first
            }
            endDate = moment(newDay).endOf("week"); // Clone for endDate
        }

        if (this.state.range === "month") {
            if (value === "today") {
                newDay = moment().startOf("month"); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "month").startOf("month"); // Clone first
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "month").startOf("month"); // Clone first
            }
            endDate = moment(newDay).endOf("month"); // Clone for endDate
        }

        displayString = this.getDisplayString(newDay, this.state.range);
        
        this.setState({ selectedDate: newDay, startDate: newDay, endDate, displayString });
    };

    handleRange = (event) => {
        const { value } = event.currentTarget;
        var displayString = "";
        var newDay = moment(this.state.selectedDate || this.state.today);
        var endDate = "";

        if (value === "week") {
            newDay = moment(newDay).startOf('week'); // Clone first
            endDate = moment(newDay).endOf('week'); // Clone for endDate
        }
        if (value === "month") {
            newDay = moment(newDay).startOf('month'); // Clone first
            endDate = moment(newDay).endOf('month'); // Clone for endDate
        }
        if (value === "day") {
            endDate = moment(newDay); // Clone for endDate
        }

        displayString = this.getDisplayString(newDay, value);
        this.setState({ range: value, selectedDate: newDay, startDate: newDay, endDate, displayString });
    };

    // UPDATED: Handle multiple card expansion
    handleCardExpansion = (dateString) => {
        const { expandedCards } = this.state;
        const newExpandedCards = new Set(expandedCards);
        
        // Toggle the card - if it's expanded, collapse it; if collapsed, expand it
        if (newExpandedCards.has(dateString)) {
            newExpandedCards.delete(dateString);
        } else {
            newExpandedCards.add(dateString);
        }
        
        this.setState({ 
            expandedCards: newExpandedCards
        });
    };

    // NEW: Set default expanded state for today's card (called after data loads)
    setDefaultExpandedCardsIfNeeded = () => {
        // Only set defaults if no cards are currently expanded
        if (this.state.expandedCards.size === 0) {
            // Build the unique days list same as in render
            const displayWorkTable = this.buildDisplayWorkTable();
            let uniqueDays = displayWorkTable.map(i => i.startDateString);
            const uniques = Array.from(new Set(uniqueDays));
            
            const todayString = moment().format(DATE_FORMAT);
            
            // If today's date exists in the unique dates, expand it by default
            if (uniques.includes(todayString)) {
                this.setState({ 
                    expandedCards: new Set([todayString])
                });
            }
        }
    };

    // Helper method to build display work table (extracted from render)
    buildDisplayWorkTable = () => {
        const { calendarDays, selectedTechnician, technicians } = this.state;

        // Filter and prepare display data
        var startDate = moment(this.state.startDate || this.state.today).startOf("day");
        var endDate = moment(this.state.endDate || startDate).endOf("day");

        // Make sure both are valid moment objects
        if (!startDate.isValid() || !endDate.isValid()) {
            return [];
        }

        let displayWorkTable = [];

        for (let i = 0; i < calendarDays.length; i++) {
            const appointment = calendarDays[i];
            const jobDuration = Math.max(Math.ceil(appointment.duration || 1), 1); // At least 1 full day
            const startMoment = moment(appointment.workDate);

            // Get assigned technician info if available
            let assignedTechnicianName = null;
            if (appointment.assigned_technician_id) {
                const assignedTech = technicians.find(t => t.User_id === appointment.assigned_technician_id);
                if (assignedTech) {
                    assignedTechnicianName = assignedTech.user_name || assignedTech.Email;
                }
            }

            // Apply technician filter - if a specific technician is selected, only show their services
            if (selectedTechnician !== "All Technicians") {
                if (!assignedTechnicianName || assignedTechnicianName !== selectedTechnician) {
                    continue; // Skip this appointment if it doesn't match the filter
                }
            }

            // Use actual work dates from server if available, fall back to consecutive expansion
            const actualDates = appointment.workDates && appointment.workDates.length > 0
                ? appointment.workDates.map(d => moment(d).format('YYYY-MM-DD'))
                : Array.from({ length: jobDuration }, (_, i) => moment(startMoment).add(i, 'days').format('YYYY-MM-DD'));

            actualDates.forEach((dateStr, idx) => {
                const currentDay = moment(dateStr);

                if (currentDay.isBetween(startDate, endDate, null, '[]')) {
                    const view = {
                        viewKey: appointment.requestId.toString() + appointment.serviceId.toString() + dateStr,
                        requestType: appointment.requestType,
                        requestId: appointment.requestId,
                        serviceId: appointment.serviceId,
                        startDate: dateStr,
                        startDateString: currentDay.format(DATE_FORMAT),
                        dueDate: appointment.dueDate,
                        dueDateString: moment(appointment.dueDate).format(DATE_FORMAT),
                        workString: appointment.category + " - " + appointment.description + " on " + appointment.year + " " +
                            appointment.make + " " + appointment.model + " " + appointment.trim + " for " +
                            appointment.dealerName,
                        estimate: appointment.duration,
                        eventId: appointment.eventId,
                        isInCalendar: !!appointment.eventId,
                        // Multi-day job properties
                        currentDay: idx + 1,
                        totalDays: actualDates.length,
                        isMultiDay: actualDates.length > 1,
                        originalWorkDate: appointment.workDate,
                        // Technician assignment info
                        assignedTechnicianId: appointment.assigned_technician_id || null,
                        assignedTechnicianName: assignedTechnicianName,
                        // Location info
                        location_id: appointment.location_id,
                        locationName: appointment.locationName || appointment.location_name,
                        // Parsed fields for grid/popover (avoids re-parsing workString)
                        category: appointment.category || '',
                        serviceDescription: appointment.customDescription || appointment.description || '',
                        vehicleYear: appointment.year || '',
                        vehicleMake: appointment.make || '',
                        vehicleModel: appointment.model || '',
                        vehicleTrim: appointment.trim || '',
                        customerName: appointment.dealerName || '',
                        dealerName: appointment.dealerName || '',
                        workStatus: appointment.workStatus || '',
                        serviceAmount: appointment.serviceAmount || 0,
                        serviceDiscount: appointment.serviceDiscount || 0,
                    };
                    displayWorkTable.push(view);
                }
            });
        }

        return displayWorkTable;
    };

    authorizeGoogle = async () => {
        try {
            let userSetup = `/request`;        
            const { data: creds } = await API.get(userSetup);
            this.navigate(creds);
        } catch (error) {
            console.error('Error authorizing Google:', error);
            alert('Error connecting to Google Calendar. Please try again.');
        }
    };

    getVisibleJobCount = (displayWorkTable) => {
        // Count unique jobs in current view only
        const visibleJobIds = new Set(displayWorkTable.map(item => item.requestId));
        return visibleJobIds.size;
    };

    // FIXED: Revenue calculation with discount subtraction
    getVisibleRevenue = (displayWorkTable) => {
        // Calculate revenue for visible services only, subtracting discounts
        return displayWorkTable.reduce((total, item) => {
            // Find the original appointment to get serviceAmount and serviceDiscount
            const originalAppointment = this.state.calendarDays.find(
                appt => appt.requestId === item.requestId && appt.serviceId === item.serviceId
            );
            
            const serviceAmount = parseFloat(originalAppointment?.serviceAmount) || 0;
            const serviceDiscount = parseFloat(originalAppointment?.serviceDiscount) || 0;
            
            // Subtract discount from service amount
            const netRevenue = serviceAmount - serviceDiscount;
            
            return total + netRevenue;
        }, 0);
    };

    getVisibleCapacityUtilization = (displayWorkTable) => {
        // Calculate capacity for visible period only
        const dailyCapacity = this.state.installer.capacity || DEFAULT_CAPACITY;
        const totalDays = displayWorkTable.reduce((total, item) => {
            return total + (parseFloat(item.estimate) || 0);
        }, 0);
        
        // Calculate available capacity based on date range
        const startDate = moment(this.state.startDate || this.state.today);
        const endDate = moment(this.state.endDate || startDate);
        const periodDays = endDate.diff(startDate, 'days') + 1;
        const availableCapacity = dailyCapacity * periodDays;
        
        return availableCapacity > 0 ? Math.round((totalDays / availableCapacity) * 100) : 0;
    };

    // Export week schedule as PDF using existing jsPDF and html2canvas
    exportWeekSchedule = async () => {
        // Only allow export when week view is selected
        if (this.state.range !== "week") {
            alert("Export is only available in Week view. Please switch to Week view first.");
            return;
        }

        this.setState({ loading: true });

        try {
            // Get the current week's start and end dates
            const startDate = moment(this.state.startDate);
            const endDate = moment(this.state.endDate);
            
            // Prepare data for the week
            const weekData = this.prepareWeekData(startDate, endDate);
            
            // Create a temporary hidden div with the schedule content
            const tempScheduleDiv = document.createElement('div');
            tempScheduleDiv.id = 'temp-schedule-for-pdf';
            tempScheduleDiv.style.position = 'absolute';
            tempScheduleDiv.style.left = '-9999px';
            tempScheduleDiv.style.top = '-9999px';
            tempScheduleDiv.style.width = '800px';
            tempScheduleDiv.style.backgroundColor = 'white';
            tempScheduleDiv.style.padding = '30px';
            tempScheduleDiv.style.fontFamily = 'Arial, sans-serif';

            // Days of the week
            const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            
            // Build the simple schedule HTML
            let scheduleHTML = `
                <div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; color: #333;">
                    <!-- Header -->
                    <div style="text-align: center; margin-bottom: 25px; border-bottom: 2px solid #3FB2BE; padding-bottom: 15px;">
                        <h1 style="font-size: 22px; font-weight: bold; margin: 0 0 5px 0; color: #2c3e50;">Work Schedule</h1>
                        <h2 style="font-size: 14px; color: #3FB2BE; margin: 0;">${startDate.format('MMM Do')} - ${endDate.format('MMM Do, YYYY')}</h2>
                    </div>
                    
                    <!-- Simple Table -->
                    <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
                        <thead>
                            <tr style="background-color: #3FB2BE; color: white;">
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 15%;">Day</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 35%;">Vehicle</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 50%;">Service</th>
                            </tr>
                        </thead>
                        <tbody>
            `;

            // Generate table rows for each day
            daysOfWeek.forEach((dayName, index) => {
                const dayMoment = moment(startDate).add(index, 'days');
                const dayKey = dayMoment.format('YYYY-MM-DD');
                const dayJobs = weekData[dayKey] || [];
                
                if (dayJobs.length === 0) {
                    // Empty day row
                    scheduleHTML += `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                            <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold; color: #3FB2BE;">
                                ${dayName}<br><span style="font-size: 10px; font-weight: normal; color: #666;">${dayMoment.format('MMM Do')}</span>
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; color: #999; font-style: italic;" colspan="2">
                                No scheduled services
                            </td>
                        </tr>
                    `;
                } else {
                    // First job with day name
                    const firstJob = dayJobs[0];
                    scheduleHTML += `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                            <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold; color: #3FB2BE; vertical-align: top;">
                                ${dayName}<br><span style="font-size: 10px; font-weight: normal; color: #666;">${dayMoment.format('MMM Do')}</span>
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                ${firstJob.vehicleInfo}
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                ${firstJob.serviceInfo}
                                ${firstJob.estimate && firstJob.estimate > 1 ? `<span style="color: #666; font-size: 10px;"> (${firstJob.estimate} days)</span>` : ''}
                            </td>
                        </tr>
                    `;
                    
                    // Additional jobs for the same day (without day name)
                    for (let i = 1; i < dayJobs.length; i++) {
                        const job = dayJobs[i];
                        scheduleHTML += `
                            <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                                <td style="border: 1px solid #ddd; padding: 8px;"></td>
                                <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                    ${job.vehicleInfo}
                                </td>
                                <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                    ${job.serviceInfo}
                                    ${job.estimate && job.estimate > 1 ? `<span style="color: #666; font-size: 10px;"> (${job.estimate} days)</span>` : ''}
                                </td>
                            </tr>
                        `;
                    }
                }
            });

            // Close table and add footer
            scheduleHTML += `
                        </tbody>
                    </table>
                    
                    <!-- Footer -->
                    <div style="margin-top: 20px; text-align: center; color: #666; font-size: 10px; border-top: 1px solid #ddd; padding-top: 10px;">
                        Generated on ${moment().format('MMM Do, YYYY at h:mm A')}
                    </div>
                </div>
            `;

            tempScheduleDiv.innerHTML = scheduleHTML;

            // Add to DOM temporarily
            document.body.appendChild(tempScheduleDiv);

            // Generate the canvas from the temporary div
            const canvas = await html2canvas(tempScheduleDiv, { 
                scale: 1.5, // Reduced scale for better performance
                useCORS: true,
                backgroundColor: '#ffffff',
                logging: false,
                width: 800,
                height: tempScheduleDiv.scrollHeight
            });
            
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            
            // Calculate dimensions to fit the page better
            const imgWidth = 190; // A4 width minus margins
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            // Add the image to PDF (should fit on single page with simplified layout)
            pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

            // Generate filename
            const filename = `work-schedule-${startDate.format('YYYY-MM-DD')}-to-${endDate.format('YYYY-MM-DD')}.pdf`;
            
            // Download the PDF
            pdf.save(filename);

            // Clean up - remove the temporary div
            if (document.body.contains(tempScheduleDiv)) {
                document.body.removeChild(tempScheduleDiv);
            }

            this.setState({ loading: false });

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Error generating PDF export. Please try again.');
            this.setState({ loading: false });
        }
    };

    // Helper method to prepare week data
    prepareWeekData = (startDate, endDate) => {
        const weekData = {};
        
        // Get all jobs for the current week from displayWorkTable logic
        const { calendarDays } = this.state;
        
        for (let i = 0; i < calendarDays.length; i++) {
            const appointment = calendarDays[i];
            const jobDuration = Math.max(Math.ceil(appointment.duration || 1), 1);
            const startMoment = moment(appointment.workDate);

            // Use actual work dates from server if available, fall back to consecutive expansion
            const actualDates = appointment.workDates && appointment.workDates.length > 0
                ? appointment.workDates.map(d => moment(d).format('YYYY-MM-DD'))
                : Array.from({ length: jobDuration }, (_, i) => moment(startMoment).add(i, 'days').format('YYYY-MM-DD'));

            actualDates.forEach((dateStr, idx) => {
                const currentDay = moment(dateStr);

                if (currentDay.isBetween(startDate, endDate, null, '[]')) {
                    const dayKey = dateStr;

                    if (!weekData[dayKey]) {
                        weekData[dayKey] = [];
                    }

                    // Parse the work string to get vehicle and service info
                    const { customerName, serviceName, vehicleInfo } = this.parseJobInfoForExport(appointment);

                    // Build service description
                    let serviceDescription = serviceName;
                    if (actualDates.length > 1) {
                        serviceDescription += ` (Day ${idx + 1} of ${actualDates.length})`;
                    }

                    // Add customer info if available
                    if (customerName && customerName !== 'Customer') {
                        serviceDescription += ` - ${customerName}`;
                    }

                    weekData[dayKey].push({
                        vehicleInfo: vehicleInfo,
                        serviceInfo: serviceDescription,
                        requestId: appointment.requestId,
                        serviceId: appointment.serviceId,
                        dueDate: appointment.dueDate,
                        estimate: appointment.duration,
                        requestType: appointment.requestType,
                        location_id: appointment.location_id,
                        locationName: appointment.locationName || appointment.location_name
                    });
                }
            });
        }
        
        return weekData;
    };

    // Helper method to parse job info for export
    parseJobInfoForExport = (appointment) => {
        try {
            // Build the work string like in the main component
            const workString = appointment.category + " - " + appointment.description + " on " +
                appointment.year + " " + appointment.make + " " + appointment.model + " " +
                appointment.trim + " for " + appointment.dealerName;

            const forIndex = workString.lastIndexOf(' for ');
            const onIndex = workString.indexOf(' on ');

            let customerName = appointment.dealerName || 'Customer';
            let serviceName = appointment.category + " - " + appointment.description;
            let vehicleInfo = 'Vehicle info not available';

            if (forIndex > -1) {
                customerName = workString.substring(forIndex + 5).trim();
            }

            if (onIndex > -1 && onIndex < forIndex) {
                const vehicleAndDealer = workString.substring(onIndex + 4, forIndex).trim();
                vehicleInfo = vehicleAndDealer;
            } else if (appointment.year && appointment.make && appointment.model) {
                // Fallback to building vehicle info from individual fields
                vehicleInfo = `${appointment.year} ${appointment.make} ${appointment.model}`;
                if (appointment.trim) {
                    vehicleInfo += ` ${appointment.trim}`;
                }
            }

            return { customerName, serviceName, vehicleInfo };
        } catch (error) {
            console.error('Error parsing job info for export:', error);
            return {
                customerName: appointment.dealerName || 'Customer',
                serviceName: appointment.category + " - " + appointment.description,
                vehicleInfo: 'Vehicle info not available'
            };
        }
    };

    // ==================== BLOCKED DATES / HOLIDAYS / CLOSURES ====================

    loadBlockedDates = async () => {
        try {
            // Use selected location for blocked dates, falling back to typeId for single-location
            const locationId = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
              ? this.props.selectedLocationId : this.state.typeId;
            const data = await LocationService.getBlockedDates(locationId);
            const blockedDates = data.blockedDates || [];

            // Separate holiday dates from custom closures
            // Holiday dates will be identified by checking if they match a known holiday date
            const currentYear = moment().year();
            const nextYear = currentYear + 1;

            // Get all holiday dates for current and next year
            const holidayDatesSet = new Set();
            US_HOLIDAYS.forEach(holiday => {
                holidayDatesSet.add(holiday.getDate(currentYear));
                holidayDatesSet.add(holiday.getDate(nextYear));
            });

            // Filter: dates that match holiday dates are holiday blocks
            const holidayBlockedDates = blockedDates.filter(bd => holidayDatesSet.has(bd.date));

            // Filter: dates that don't match holidays are custom closures
            // Group consecutive dates with same reason as date ranges
            const nonHolidayDates = blockedDates.filter(bd => !holidayDatesSet.has(bd.date));
            const customClosures = this.groupIntoClosure(nonHolidayDates);

            this.setState({
                holidayBlockedDates,
                customClosures
            });
        } catch (error) {
            console.error('Error loading blocked dates:', error);
        }
    };

    loadOperatingHours = async () => {
        try {
            const locationId = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
                ? this.props.selectedLocationId : this.state.typeId;
            const data = await LocationService.getOperatingHours(locationId);
            this.setState({ operatingHours: data.hours || data || [] });
        } catch (error) {
            console.error('Error loading operating hours:', error);
        }
    };

    // Group blocked dates into closures (date ranges with same reason)
    groupIntoClosure = (blockedDates) => {
        if (!blockedDates.length) return [];

        // Sort by date
        const sorted = [...blockedDates].sort((a, b) => a.date.localeCompare(b.date));
        const closures = [];
        let currentClosure = null;

        for (const bd of sorted) {
            if (!currentClosure) {
                currentClosure = {
                    start_date: bd.date,
                    end_date: bd.date,
                    reason: bd.reason
                };
            } else {
                // Check if this date is consecutive and has the same reason
                const prevDate = moment(currentClosure.end_date);
                const currDate = moment(bd.date);
                const daysDiff = currDate.diff(prevDate, 'days');

                if (daysDiff === 1 && bd.reason === currentClosure.reason) {
                    // Extend current closure
                    currentClosure.end_date = bd.date;
                } else {
                    // Start a new closure
                    closures.push(currentClosure);
                    currentClosure = {
                        start_date: bd.date,
                        end_date: bd.date,
                        reason: bd.reason
                    };
                }
            }
        }

        // Don't forget the last one
        if (currentClosure) {
            closures.push(currentClosure);
        }

        return closures;
    };

    // Format a date range for display
    formatDateRange = (startDate, endDate) => {
        const start = moment(startDate);
        const end = moment(endDate);

        if (start.isSame(end, 'day')) {
            return start.format('ddd, MMM D, YYYY');
        }

        if (start.isSame(end, 'year')) {
            return `${start.format('ddd, MMM D')} - ${end.format('ddd, MMM D, YYYY')}`;
        }

        return `${start.format('ddd, MMM D, YYYY')} - ${end.format('ddd, MMM D, YYYY')}`;
    };

    // ---- Holidays Modal Methods ----
    handleOpenHolidaysModal = () => {
        this.setState({ showHolidaysModal: true });
    };

    handleCloseHolidaysModal = () => {
        this.setState({ showHolidaysModal: false });
    };

    // Check if a specific date is blocked
    isDateBlocked = (date) => {
        return this.state.holidayBlockedDates.some(bd => bd.date === date);
    };

    // Find jobs scheduled on specific dates
    getJobsOnDates = (dates) => {
        const { calendarDays } = this.state;
        const dateSet = new Set(dates);

        return calendarDays.filter(job => {
            const jobDate = moment(job.workDate).format('YYYY-MM-DD');
            return dateSet.has(jobDate);
        });
    };

    // Format job info for warning message
    formatJobWarning = (jobs) => {
        if (jobs.length === 0) return null;

        const jobDescriptions = jobs.slice(0, 5).map(job => {
            const service = `${job.category} - ${job.description}`.trim();
            const vehicle = `${job.year} ${job.make} ${job.model}`.trim();
            const customer = job.dealerName || 'Customer';
            return `• ${service} on ${vehicle} for ${customer}`;
        }).join('\n');

        let message = `${jobs.length} job${jobs.length > 1 ? 's are' : ' is'} already scheduled:\n\n${jobDescriptions}`;

        if (jobs.length > 5) {
            message += `\n... and ${jobs.length - 5} more`;
        }

        message += '\n\nBlock this day anyway? Existing jobs will not be affected.';

        return message;
    };

    // Toggle a holiday block
    handleToggleHoliday = async (date, holidayName) => {
        const isCurrentlyBlocked = this.isDateBlocked(date);

        // If blocking (not unblocking), check for scheduled jobs
        if (!isCurrentlyBlocked) {
            const affectedJobs = this.getJobsOnDates([date]);
            if (affectedJobs.length > 0) {
                const warning = this.formatJobWarning(affectedJobs);
                if (!window.confirm(warning)) {
                    return; // User cancelled
                }
            }
        }

        try {
            this.setState({ holidaysLoading: true });
            await LocationService.toggleHoliday(this.state.typeId, date, holidayName, isCurrentlyBlocked);
            await this.loadBlockedDates();
            this.setState({ holidaysLoading: false });
        } catch (error) {
            console.error('Error toggling holiday:', error);
            alert('Failed to update holiday. Please try again.');
            this.setState({ holidaysLoading: false });
        }
    };

    // ---- Custom Closures Modal Methods ----
    handleOpenCustomClosuresModal = () => {
        this.setState({
            showCustomClosuresModal: true,
            newClosureStart: '',
            newClosureEnd: '',
            newClosureReason: ''
        });
    };

    handleCloseCustomClosuresModal = () => {
        this.setState({ showCustomClosuresModal: false });
    };

    handleAddCustomClosure = async () => {
        const { newClosureStart, newClosureEnd, newClosureReason } = this.state;

        if (!newClosureStart || !newClosureEnd || !newClosureReason.trim()) {
            alert('Please fill in all fields.');
            return;
        }

        if (moment(newClosureEnd).isBefore(moment(newClosureStart))) {
            alert('End date must be on or after start date.');
            return;
        }

        // Build list of dates in the range
        const datesToBlock = [];
        const current = moment(newClosureStart);
        const end = moment(newClosureEnd);
        while (current.isSameOrBefore(end)) {
            datesToBlock.push(current.format('YYYY-MM-DD'));
            current.add(1, 'day');
        }

        // Check for scheduled jobs in this range
        const affectedJobs = this.getJobsOnDates(datesToBlock);
        if (affectedJobs.length > 0) {
            const warning = this.formatJobWarning(affectedJobs);
            if (!window.confirm(warning)) {
                return; // User cancelled
            }
        }

        try {
            this.setState({ closuresLoading: true });
            await LocationService.addDateRange(
                this.state.typeId,
                newClosureStart,
                newClosureEnd,
                newClosureReason.trim()
            );
            await this.loadBlockedDates();
            this.setState({
                closuresLoading: false,
                newClosureStart: '',
                newClosureEnd: '',
                newClosureReason: ''
            });
        } catch (error) {
            console.error('Error adding custom closure:', error);
            alert('Failed to add closure. Please try again.');
            this.setState({ closuresLoading: false });
        }
    };

    handleRemoveClosure = async (closure) => {
        if (!window.confirm(`Remove closure "${closure.reason}" from ${this.formatDateRange(closure.start_date, closure.end_date)}?`)) {
            return;
        }

        try {
            this.setState({ closuresLoading: true });
            await LocationService.removeDateRange(this.state.typeId, closure.start_date, closure.end_date);
            await this.loadBlockedDates();
            this.setState({ closuresLoading: false });
        } catch (error) {
            console.error('Error removing closure:', error);
            alert('Failed to remove closure. Please try again.');
            this.setState({ closuresLoading: false });
        }
    };

    render() {
        const { isDesktop, calendarDays, isBulkSyncing, error, loading } = this.state;
        // Handle error state
        if (error) {
            return (
                <div className="calendar-container">
                    <div className="error-message">
                        <h3>Error Loading Calendar</h3>
                        <p>{error}</p>
                        <button onClick={() => window.location.reload()}>Refresh Page</button>
                    </div>
                </div>
            );
        }

        // Filter and prepare display data - Use the extracted method
        let displayWorkTable = this.buildDisplayWorkTable();

        // Calculate job service counts and positions
        const jobServiceCounts = {};
        calendarDays.forEach(appointment => {
            if (!jobServiceCounts[appointment.requestId]) {
                jobServiceCounts[appointment.requestId] = new Set();
            }
            jobServiceCounts[appointment.requestId].add(appointment.serviceId);
        });

        // Add service position info to display items
        displayWorkTable = displayWorkTable.map(item => {
            const totalServicesInJob = jobServiceCounts[item.requestId]?.size || 1;
            
            // Get all services for this job and sort by start date to determine order
            const jobServices = calendarDays
                .filter(appt => appt.requestId === item.requestId)
                .reduce((acc, appt) => {
                    // Only add each service once (avoid duplicates from multi-day services)
                    if (!acc.find(s => s.serviceId === appt.serviceId)) {
                        acc.push({
                            serviceId: appt.serviceId,
                            workDate: appt.workDate
                        });
                    }
                    return acc;
                }, [])
                .sort((a, b) => new Date(a.workDate) - new Date(b.workDate)); // Sort by start date
            
            const currentServicePosition = jobServices.findIndex(s => s.serviceId === item.serviceId) + 1;
            
            return {
                ...item,
                totalServicesInJob,
                currentServiceNumber: currentServicePosition
            };
        });
        
        // Calculate metrics based on VISIBLE data only
        const visibleJobCount = this.getVisibleJobCount(displayWorkTable);
        const visibleRevenue = this.getVisibleRevenue(displayWorkTable); // Now includes discount subtraction
        const visibleCapacity = this.getVisibleCapacityUtilization(displayWorkTable);
const visibleUnsyncedCount = displayWorkTable.filter(job => 
    !job.isInCalendar && moment(job.startDate).isSameOrAfter(moment().startOf('day'))
).length;
        // Update display string with visible service count (not job count)
        const totalVisibleServices = displayWorkTable.length;
        const displayStringWithCount = this.getDisplayString(
            moment(this.state.selectedDate || this.state.today), 
            this.state.range, 
            totalVisibleServices
        ).replace(' job', ' service'); // Change "jobs" to "services" in the display

        // Get unique days for card display
        let uniqueDays = displayWorkTable.map(i => i.startDateString);
        const uniques = Array.from(new Set(uniqueDays));

        // Get blocked periods (holidays + custom closures) that overlap with visible range
        const startDate = moment(this.state.startDate || this.state.today).startOf("day");
        const endDate = moment(this.state.endDate || startDate).endOf("day");
        const blockedPeriodsInRange = [];

        // Add holidays as single-day periods
        this.state.holidayBlockedDates.forEach(bd => {
            const bdMoment = moment(bd.date);
            if (bdMoment.isBetween(startDate, endDate, null, '[]')) {
                blockedPeriodsInRange.push({
                    start_date: bd.date,
                    end_date: bd.date,
                    reason: bd.reason,
                    type: 'holiday'
                });
            }
        });

        // Add custom closures (already grouped as date ranges)
        this.state.customClosures.forEach(closure => {
            const closureStart = moment(closure.start_date);
            const closureEnd = moment(closure.end_date);
            // Check if closure overlaps with visible range
            if (closureStart.isSameOrBefore(endDate) && closureEnd.isSameOrAfter(startDate)) {
                blockedPeriodsInRange.push({
                    start_date: closure.start_date,
                    end_date: closure.end_date,
                    reason: closure.reason,
                    type: 'closure'
                });
            }
        });

        // Add closed weekdays from operating hours
        if (this.state.operatingHours.length > 0) {
            const closedDays = this.state.operatingHours.filter(h => !h.is_open).map(h => h.day_of_week);
            if (closedDays.length > 0) {
                let cursor = moment(startDate);
                while (cursor.isSameOrBefore(endDate, 'day')) {
                    if (closedDays.includes(cursor.day())) {
                        const dateStr = cursor.format('YYYY-MM-DD');
                        // Don't duplicate if already blocked by holiday/closure
                        const alreadyBlocked = blockedPeriodsInRange.some(p => dateStr >= p.start_date && dateStr <= p.end_date);
                        if (!alreadyBlocked) {
                            blockedPeriodsInRange.push({
                                start_date: dateStr,
                                end_date: dateStr,
                                reason: '',
                                type: 'hours'
                            });
                        }
                    }
                    cursor.add(1, 'day');
                }
            }
        }

        // Sort blocked periods by start date
        blockedPeriodsInRange.sort((a, b) => a.start_date.localeCompare(b.start_date));

        return (
            <React.Fragment>
                <div className={`calendar-container ${isDesktop ? 'desktop' : 'mobile'}`}>
                    {/* Header */}
                    <div className="calendar-header">
                        <div className="header-content">
                            <div className="header-nav">
                                {isDesktop && (
                                    <div className="view-toggle">
                                        <button 
                                            className={this.state.range === "day" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="day"
                                        >
                                            Day
                                        </button>
                                        <button 
                                            className={this.state.range === "week" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="week"
                                        >
                                            Week
                                        </button>
                                        <button 
                                            className={this.state.range === "month" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="month"
                                        >
                                            Month
                                        </button>
                                    </div>
                                )}
                                <div className="date-display">
                                    {displayStringWithCount}
                                </div>
                                <ButtonGroup className="nav-controls">
                                    <Button variant="outline-secondary" onClick={this.handleDisplayRange} value="less">
                                        ←
                                    </Button>
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={this.handleDisplayRange} 
                                        value="today"
                                        active={moment(this.state.selectedDate).isSame(this.state.today, 'day')}
                                    >
                                        Today
                                    </Button>
                                    <Button variant="outline-secondary" onClick={this.handleDisplayRange} value="more">
                                        →
                                    </Button>
                                </ButtonGroup>
                                <Link to="/newestimate/" className="btn btn-primary new-estimate-btn">
                                    + New Estimate
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Overview Dashboard */}
                    <div className="overview-cards">
                        <div className="overview-card">
                            <div className="number">{visibleJobCount}</div>
                            <div className="label">Jobs This Period</div>
                        </div>
                        <div className="overview-card">
                            <div className="number">{visibleCapacity}%</div>
                            <div className="label">Capacity Used</div>
                        </div>
                        {isDesktop && (
                            <div className="overview-card">
                                <div className="number">${visibleRevenue.toFixed(0)}</div>
                                <div className="label">{this.getPeriodRevenueLabel()}</div>
                            </div>
                        )}
                    </div>

                    {/* Technician Filter Section - only show if shop has technicians */}
                    {this.state.hasTechnicians && (
                        <div className="filters-section">
                            <div className="filter-controls">
                                <div className="filter-group">
                                    <Select
                                        name="technicianFilter"
                                        label="Filter by Technician:"
                                        options={this.state.technicianOptions}
                                        value={this.state.selectedTechnician}
                                        onChange={this.handleTechnicianChange}
                                    />
                                </div>
                                {this.state.selectedTechnician !== "All Technicians" && (
                                    <button
                                        className="btn btn-link p-0 ml-2 clear-filter-btn"
                                        onClick={() => this.setState({ selectedTechnician: "All Technicians" })}
                                        type="button"
                                    >
                                        CLEAR FILTER
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

{/* Quick Actions (Desktop Only) - SIMPLIFIED */}
{isDesktop && (
    <div className="bulk-actions">
        {/* View Mode Toggle */}
        <div className="view-mode-toggle">
            <button
                className={this.state.viewMode === 'cards' ? 'active' : ''}
                onClick={() => this.setState({ viewMode: 'cards' })}
                title="Card View"
            >
                <i className="fa-sharp fa-regular fa-rectangle-vertical-history" />
                Cards
            </button>
            <button
                className={this.state.viewMode === 'grid' ? 'active' : ''}
                onClick={() => this.setState({ viewMode: 'grid' })}
                title="Grid View"
            >
                <i className="fa-sharp fa-regular fa-calendar-days" />
                Grid
            </button>
        </div>

        <div className="label">Quick Actions:</div>

        {/* Calendar Connection & Sync - only at location level (calendars are per-location) */}
        {this.props.selectedLocationId && this.props.selectedLocationId !== 'all' && (
          <>
<div className="calendar-connection-actions">
  {this.state.isCalendarConnected ? (
    <>
      <button
        className="action-btn connect-btn"
        onClick={this.disconnectCalendar}
        title="Disconnect Google Calendar"
      >
        🔗 Disconnect Calendar
      </button>

      {/* Sync Actions (only show if connected) */}
      {visibleUnsyncedCount > 0 ? (
        <button
          className="bulk-sync-btn"
          onClick={this.handleBulkSync}
          disabled={isBulkSyncing}
        >
          {isBulkSyncing ? (
            <>⏳ Syncing...</>
          ) : (
            <>📅 Sync All to Calendar ({visibleUnsyncedCount} services)</>
          )}
        </button>
      ) : (
        <span className="sync-status">All jobs synced to calendar</span>
      )}
    </>
  ) : (
    <>
      <button
        className="action-btn connect-btn"
        onClick={this.connectCalendar}
      >
        🔗 Connect Google Calendar
      </button>
      {this.state.calendarConnectionError && (
        <div className="connection-error">
          {this.state.calendarConnectionError}
        </div>
      )}
    </>
  )}
</div>

        {/* Calendar Selection Modal */}
{this.state.showCalendarSelection && (
  <CalendarSelectionModal
    calendars={this.state.availableCalendars}
    installerId={this.state.typeId}
    onSelect={this.handleCalendarSelection}
    onCancel={() => this.setState({ showCalendarSelection: false, availableCalendars: [] })}
  />
)}
          </>
        )}

        {/* Export Action - available at all levels */}
        {this.state.range === "week" ? (
            <button
                className="action-btn export-btn"
                onClick={this.exportWeekSchedule}
                title="Export current week as PDF"
                disabled={loading}
            >
                {loading ? (
                    <>⏳ Generating...</>
                ) : (
                    <>📊 Export Week</>
                )}
            </button>
        ) : (
            <button
                className="action-btn disabled"
                disabled
                title="Export is only available in Week view"
            >
                📊 Export Week
            </button>
        )}

        {/* Holidays & Closures Actions - only at location level */}
        {this.props.selectedLocationId && this.props.selectedLocationId !== 'all' && (
          <>
            <button
                className="action-btn"
                onClick={this.handleOpenHolidaysModal}
                title="Manage holiday closures"
            >
                🎄 Manage Holidays
            </button>
            <button
                className="action-btn"
                onClick={this.handleOpenCustomClosuresModal}
                title="Manage custom closures"
            >
                📅 Custom Closures
            </button>
          </>
        )}
    </div>
)}
                    {/* Calendar Content — Grid or Cards */}
                    {this.state.viewMode === 'grid' && isDesktop && moment.isMoment(this.state.startDate) ? (
                        <CalendarGrid
                            range={this.state.range}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            displayWorkTable={displayWorkTable}
                            blockedPeriodsInRange={blockedPeriodsInRange}
                            locations={this.props.locations}
                            selectedLocationId={this.props.selectedLocationId}
                            onDisplayDetails={this.displayDetails}
                            calendarDays={this.state.calendarDays}
                        />
                    ) : (
                        <div className={`calendar-grid ${isDesktop ? 'desktop-grid' : 'mobile-grid'}`}>
                            {/* Blocked periods (holidays & closures) */}
                            {blockedPeriodsInRange.map((period, index) => {
                                const isSingleDay = period.start_date === period.end_date;
                                const dateDisplay = isSingleDay
                                    ? moment(period.start_date).format('ddd, MMM D')
                                    : `${moment(period.start_date).format('ddd, MMM D')} - ${moment(period.end_date).format('ddd, MMM D')}`;

                                return (
                                    <div
                                        className="blocked-date-card clickable"
                                        key={`blocked-${index}`}
                                        onClick={() => period.type === 'holiday'
                                            ? this.handleOpenHolidaysModal()
                                            : this.handleOpenCustomClosuresModal()
                                        }
                                        title="Click to manage"
                                    >
                                        <div className="blocked-date-header">
                                            <span className="blocked-date-icon">
                                                {period.type === 'holiday' ? '🎄' : '🚫'}
                                            </span>
                                            <span className="blocked-date-title">{dateDisplay}</span>
                                        </div>
                                        <div className="blocked-date-reason">
                                            <strong>CLOSED</strong> — {period.reason}
                                        </div>
                                        <div className="blocked-date-hint">
                                            Click to manage
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Job cards */}
                            {uniques.map((dateString, index) => {
                                const cardIsExpanded = this.state.expandedCards.has(dateString);

                                return (
                                    <CalendarCard
                                        key={dateString}
                                        date={dateString}
                                        workTable={displayWorkTable}
                                        onDisplayDetails={this.displayDetails}
                                        isDesktop={isDesktop}
                                        isExpanded={cardIsExpanded}
                                        onCardExpansion={this.handleCardExpansion}
                                        locations={this.props.locations}
                                        selectedLocationId={this.props.selectedLocationId}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* Job Details Modal */}
                <ViewJob
                    show={this.state.showDetails}
                    onHide={this.addCustomClose}
                    request={this.state.selectedRequestimate}
                    services={this.state.services}
                    notes={this.state.notes}
                />

                {/* Holidays Modal */}
                <Modal show={this.state.showHolidaysModal} onHide={this.handleCloseHolidaysModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Holiday Closures</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-muted mb-4">
                            Select holidays when your shop will be closed. Changes are saved immediately.
                        </p>

                        {this.state.holidaysLoading && (
                            <div className="text-center mb-3">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}

                        {/* Current Year Holidays - only show future holidays */}
                        {(() => {
                            const today = moment().startOf('day');
                            const currentYear = moment().year();
                            const currentYearHolidays = US_HOLIDAYS.filter(holiday => {
                                const date = holiday.getDate(currentYear);
                                return moment(date).isSameOrAfter(today);
                            });

                            if (currentYearHolidays.length === 0) return null;

                            return (
                                <>
                                    <h6 className="mb-3">{currentYear} Holidays</h6>
                                    <div className="holiday-checklist mb-4">
                                        {currentYearHolidays.map(holiday => {
                                            const date = holiday.getDate(currentYear);
                                            const isBlocked = this.isDateBlocked(date);
                                            return (
                                                <div className="holiday-item d-flex align-items-center py-2 border-bottom" key={`${holiday.id}-${currentYear}`}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id={`holiday-${holiday.id}-${currentYear}`}
                                                            checked={isBlocked}
                                                            onChange={() => this.handleToggleHoliday(date, holiday.name)}
                                                            disabled={this.state.holidaysLoading}
                                                        />
                                                        <label className="custom-control-label" htmlFor={`holiday-${holiday.id}-${currentYear}`}>
                                                            <strong>{holiday.name}</strong>
                                                            <span className="text-muted ml-2">{formatHolidayDate(date)}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            );
                        })()}

                        {/* Next Year Holidays - only show future holidays */}
                        {(() => {
                            const today = moment().startOf('day');
                            const nextYear = moment().year() + 1;
                            const nextYearHolidays = US_HOLIDAYS.filter(holiday => {
                                const date = holiday.getDate(nextYear);
                                return moment(date).isSameOrAfter(today);
                            });

                            if (nextYearHolidays.length === 0) return null;

                            return (
                                <>
                                    <h6 className="mb-3">{nextYear} Holidays</h6>
                                    <div className="holiday-checklist">
                                        {nextYearHolidays.map(holiday => {
                                            const date = holiday.getDate(nextYear);
                                            const isBlocked = this.isDateBlocked(date);
                                            return (
                                                <div className="holiday-item d-flex align-items-center py-2 border-bottom" key={`${holiday.id}-${nextYear}`}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id={`holiday-${holiday.id}-${nextYear}`}
                                                            checked={isBlocked}
                                                            onChange={() => this.handleToggleHoliday(date, holiday.name)}
                                                            disabled={this.state.holidaysLoading}
                                                        />
                                                        <label className="custom-control-label" htmlFor={`holiday-${holiday.id}-${nextYear}`}>
                                                            <strong>{holiday.name}</strong>
                                                            <span className="text-muted ml-2">{formatHolidayDate(date)}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            );
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseHolidaysModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Custom Closures Modal */}
                <Modal show={this.state.showCustomClosuresModal} onHide={this.handleCloseCustomClosuresModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Custom Closures</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-muted mb-4">
                            Block date ranges for vacations, training, or other closures.
                        </p>

                        {/* Add New Closure Form */}
                        <div className="card p-3 mb-4 bg-light">
                            <h6 className="mb-3">Add New Closure</h6>
                            <div className="form-row align-items-end">
                                <div className="col-md-3">
                                    <label className="small font-weight-bold">From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.newClosureStart}
                                        onChange={(e) => this.setState({ newClosureStart: e.target.value })}
                                        min={moment().format('YYYY-MM-DD')}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="small font-weight-bold">To</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.newClosureEnd}
                                        onChange={(e) => this.setState({ newClosureEnd: e.target.value })}
                                        min={this.state.newClosureStart || moment().format('YYYY-MM-DD')}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="small font-weight-bold">Reason</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g., Vacation, Training"
                                        value={this.state.newClosureReason}
                                        onChange={(e) => this.setState({ newClosureReason: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={this.handleAddCustomClosure}
                                        disabled={!this.state.newClosureStart || !this.state.newClosureEnd || !this.state.newClosureReason || this.state.closuresLoading}
                                    >
                                        {this.state.closuresLoading ? 'Adding...' : 'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Existing Custom Closures List */}
                        <h6 className="mb-3">Scheduled Closures</h6>
                        {this.state.customClosures.length === 0 ? (
                            <p className="text-muted">No custom closures scheduled.</p>
                        ) : (
                            <div className="closures-list">
                                {this.state.customClosures.map((closure, idx) => (
                                    <div className="closure-item d-flex justify-content-between align-items-center p-3 border-bottom" key={idx}>
                                        <div>
                                            <strong>{this.formatDateRange(closure.start_date, closure.end_date)}</strong>
                                            <span className="text-muted ml-2">— {closure.reason}</span>
                                        </div>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => this.handleRemoveClosure(closure)}
                                            disabled={this.state.closuresLoading}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseCustomClosuresModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <style>{`
                    .calendar-container {
                        max-width: 1400px;
                        margin: 0 auto;
                        padding: 24px;
                        background: #f8fafc;
                        min-height: 100vh;
                    }

                    .calendar-container.mobile {
                        padding: 16px;
                    }

                    .error-message {
                        background: white;
                        border: 1px solid #fecaca;
                        border-radius: 8px;
                        padding: 24px;
                        text-align: center;
                        color: #dc2626;
                    }

                    .error-message button {
                        background: #dc2626;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                        margin-top: 12px;
                    }

                    .calendar-header {
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 8px;
                        padding: 24px;
                        margin-bottom: 24px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .calendar-header {
                        padding: 16px;
                        margin-bottom: 16px;
                    }

                    .header-content {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 16px;
                    }

                    .mobile .header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .header-nav {
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        flex-wrap: wrap;
                        width: 100%;
                        justify-content: space-between;
                    }

                    .mobile .header-nav {
                        justify-content: space-between;
                    }

                    .view-toggle {
                        display: flex;
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 6px;
                        overflow: hidden;
                    }

                    .view-toggle button {
                        background: white;
                        border: none;
                        padding: 8px 16px;
                        font-size: 13px;
                        font-weight: 500;
                        color: #6b7280;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .view-toggle button:hover {
                        background: #f9fafb;
                    }

                    .view-toggle button.active {
                        background: #3FB2BE;
                        color: white;
                    }

                    .date-display {
                        font-size: 16px;
                        font-weight: 500;
                        color: #374151;
                        padding: 0 16px;
                    }

                    .mobile .date-display {
                        text-align: center;
                        padding: 8px 0;
                        order: -1;
                    }

                    .new-estimate-btn {
                        background: #3FB2BE !important;
                        border-color: #3FB2BE !important;
                        font-weight: 600;
                        text-decoration: none;
                    }

                    .new-estimate-btn:hover {
                        background: #359ca6 !important;
                        border-color: #359ca6 !important;
                        text-decoration: none;
                    }

                    .overview-cards {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 16px;
                        margin-bottom: 24px;
                    }

                    .mobile .overview-cards {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 12px;
                        margin-bottom: 16px;
                    }

                    .overview-card {
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 8px;
                        padding: 20px;
                        text-align: center;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .overview-card {
                        padding: 16px 12px;
                    }

                    .overview-card .number {
                        font-size: 28px;
                        font-weight: 700;
                        color: #374151;
                        margin-bottom: 4px;
                    }

                    .mobile .overview-card .number {
                        font-size: 20px;
                    }

                    .overview-card .label {
                        font-size: 12px;
                        color: #6b7280;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .overview-card.urgent .number {
                        color: #dc3545;
                    }

                    .bulk-actions {
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 8px;
                        padding: 16px;
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .bulk-actions .label {
                        font-size: 14px;
                        font-weight: 500;
                        color: #374151;
                    }

                    .calendar-connection-actions {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .calendar-sync-actions {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .connect-btn {
                        background: #3FB2BE !important;
                        color: white !important;
                        border-color: #3FB2BE !important;
                    }

                    .connect-btn:hover {
                        background: #359ca6 !important;
                        border-color: #359ca6 !important;
                    }

                    .connection-error {
                        color: #dc2626;
                        font-size: 12px;
                        background: #fef2f2;
                        padding: 4px 8px;
                        border-radius: 4px;
                        border: 1px solid #fecaca;
                    }

                    .bulk-sync-btn {
                        background: #3FB2BE;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .bulk-sync-btn:hover:not(:disabled) {
                        background: #359ca6;
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(63, 178, 190, 0.3);
                    }

                    .bulk-sync-btn:disabled {
                        opacity: 0.6;
                        cursor: not-allowed;
                        transform: none;
                    }

                    .action-btn {
                        background: white;
                        border: 1px solid #e5e7eb;
                        color: #6b7280;
                        padding: 8px 16px;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .action-btn:hover:not(:disabled) {
                        border-color: #d1d5db;
                        background: #fafafa;
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }

                    .sync-status {
                        color: #166534;
                        font-size: 13px;
                        font-weight: 500;
                        padding: 8px 16px;
                        background: #dcfce7;
                        border-radius: 6px;
                    }

                    .calendar-grid.desktop-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
                        gap: 20px;
                    }

                    .calendar-grid.mobile-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    /* Blocked Date Card Styles */
                    .blocked-date-card {
                        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
                        border: 2px solid #f59e0b;
                        border-radius: 8px;
                        padding: 16px;
                        box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
                    }

                    .blocked-date-card.clickable {
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .blocked-date-card.clickable:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
                        border-color: #d97706;
                    }

                    .blocked-date-header {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 8px;
                    }

                    .blocked-date-icon {
                        font-size: 20px;
                    }

                    .blocked-date-title {
                        font-size: 14px;
                        font-weight: 600;
                        color: #92400e;
                    }

                    .blocked-date-reason {
                        font-size: 14px;
                        color: #b45309;
                    }

                    .blocked-date-reason strong {
                        color: #92400e;
                    }

                    .blocked-date-hint {
                        font-size: 11px;
                        color: #b45309;
                        margin-top: 8px;
                        opacity: 0.7;
                    }

                    .blocked-date-card.clickable:hover .blocked-date-hint {
                        opacity: 1;
                    }

                    .export-btn {
                        background: #10b981 !important;
                        color: white !important;
                        border-color: #10b981 !important;
                    }

                    .export-btn:hover:not(:disabled) {
                        background: #059669 !important;
                        border-color: #059669 !important;
                        color: white !important;
                    }

                    .action-btn.disabled {
                        background: #f3f4f6 !important;
                        color: #9ca3af !important;
                        border-color: #e5e7eb !important;
                        cursor: not-allowed !important;
                    }

                    .action-btn.disabled:hover {
                        background: #f3f4f6 !important;
                        color: #9ca3af !important;
                        border-color: #e5e7eb !important;
                        transform: none !important;
                        box-shadow: none !important;
                    }

                    /* Technician Filter Styles (following newFinancials pattern) */
                    .filters-section {
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 8px;
                        padding: 16px 20px;
                        margin-bottom: 16px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .filter-controls {
                        display: flex;
                        gap: 16px;
                        align-items: center;
                        flex-wrap: wrap;
                    }

                    .mobile .filter-controls {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }

                    .filter-group {
                        min-width: 200px;
                    }

                    .filter-group .form-group {
                        margin-bottom: 0;
                    }

                    .filter-group label {
                        font-size: 14px;
                        font-weight: 500;
                        color: #374151;
                        margin-bottom: 4px;
                    }

                    .filter-group .form-control {
                        font-size: 14px;
                        padding: 8px 12px;
                        border: 1px solid #d1d5db;
                        border-radius: 6px;
                    }

                    .filter-group .form-control:focus {
                        border-color: #3FB2BE;
                        box-shadow: 0 0 0 2px rgba(63, 178, 190, 0.1);
                    }

                    .clear-filter-btn {
                        font-size: 13px;
                        color: #6b7280;
                        text-decoration: underline;
                    }

                    .clear-filter-btn:hover {
                        color: #374151;
                    }

                    @media (max-width: 768px) {
                        .calendar-grid.desktop-grid {
                            grid-template-columns: 1fr;
                            gap: 12px;
                        }
                    }
                        .calendar-connection-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.connection-status {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  white-space: nowrap;
}

.connection-status:contains("✅") {
  color: #166534;
  background: #dcfce7;
}

.connection-status:contains("Not Connected") {
  color: #dc2626;
  background: #fef2f2;
}

.disconnect-btn {
  background: #ef4444 !important;
  color: white !important;
  border-color: #ef4444 !important;
}

.disconnect-btn:hover:not(:disabled) {
  background: #dc2626 !important;
  border-color: #dc2626 !important;
  color: white !important;
}

.connect-btn {
  background: #3FB2BE !important;
  color: white !important;
  border-color: #3FB2BE !important;
}

.connect-btn:hover:not(:disabled) {
  background: #359ca6 !important;
  border-color: #359ca6 !important;
}
                `}</style>
            </React.Fragment>
        );
    }
}
// Calendar Selection Modal Component (moved from navBar.jsx)
const CalendarSelectionModal = ({ calendars, installerId, onSelect, onCancel }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  }} onClick={onCancel}>
    <div style={{
      backgroundColor: 'white', borderRadius: '8px', padding: '30px',
      maxWidth: '550px', width: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      maxHeight: '80vh', overflow: 'auto'
    }} onClick={e => e.stopPropagation()}>
      
      <div className="text-center mb-4">
        <h4>Select Your Business Calendar</h4>
        <p className="text-muted mb-2">
          Choose which Google Calendar to sync jobs for <strong>this location</strong>:
        </p>
      </div>
      
      <div style={{ maxHeight: '300px', overflow: 'auto' }}>
        {calendars.map((calendar, index) => (
          <div key={calendar.id} style={{
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '12px',
            cursor: 'pointer',
            backgroundColor: calendar.primary ? '#f0f9ff' : 'white',
            borderColor: calendar.primary ? '#3FB2BE' : '#e5e7eb',
            transition: 'all 0.2s ease'
          }} 
          onClick={() => onSelect(calendar)}
          onMouseEnter={(e) => {
            e.target.style.borderColor = '#3FB2BE';
            e.target.style.backgroundColor = '#f8fafc';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = calendar.primary ? '#3FB2BE' : '#e5e7eb';
            e.target.style.backgroundColor = calendar.primary ? '#f0f9ff' : 'white';
          }}>
            
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between' 
            }}>
              <div>
                <div style={{ 
                  fontWeight: '600', 
                  fontSize: '16px',
                  marginBottom: '4px',
                  color: '#374151'
                }}>
                  {calendar.name}
                </div>
              </div>
              
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '2px solid #d1d5db',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {calendar.primary && (
                  <div style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#3FB2BE',
                    borderRadius: '50%'
                  }} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="text-center mt-4">
        <button 
          className="btn btn-outline-secondary btn-lg"
          onClick={onCancel}
          style={{ minWidth: '120px' }}
        >
          CANCEL SETUP
        </button>
        
      </div>
    </div>
  </div>
);

export default Calendar;